import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "mt-10 mb-20" }
const _hoisted_4 = { class: "mb-20" }
const _hoisted_5 = { class: "mt-20 mb-20" }
const _hoisted_6 = { class: "card-grid-container" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "card-footer" }
const _hoisted_10 = { class: "mr-40" }
const _hoisted_11 = { class: "card-footer-title" }
const _hoisted_12 = { class: "card-footer-title" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_CopyToClipboardText = _resolveComponent("CopyToClipboardText")!
  const _component_DateComponent = _resolveComponent("DateComponent")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_rc_item_card = _resolveComponent("rc-item-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.value)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : (_ctx.showSecrets)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.errors && _ctx.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (err, i) => {
                    return (_openBlock(), _createBlock(_component_Banner, {
                      key: i,
                      color: "error",
                      "data-testid": `error-banner${i}`,
                      label: err
                    }, null, 8, ["data-testid", "label"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _createElementVNode("h3", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.t('oidcclient.clientId')) + ":\n        ", 1),
              _createVNode(_component_CopyToClipboardText, {
                "aria-label": _ctx.t('oidcclient.a11y.copyText.clientId'),
                text: _ctx.clientID,
                "data-testid": "oidc-clients-copy-clipboard-client-id"
              }, null, 8, ["aria-label", "text"])
            ]),
            _cache[11] || (_cache[11] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t('oidcclient.clientSecrets')), 1),
              _cache[8] || (_cache[8] = _createTextVNode()),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientSecrets, (secret, i) => {
                  return (_openBlock(), _createBlock(_component_rc_item_card, {
                    id: secret.id,
                    key: secret.id,
                    class: "card-item",
                    header: secret.header,
                    image: secret.image,
                    value: secret,
                    variant: "medium",
                    clickable: false
                  }, {
                    "item-card-content": _withCtx(() => [
                      (secret.displayFullSecret)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            _createVNode(_component_CopyToClipboardText, {
                              "aria-label": _ctx.t('oidcclient.a11y.copyText.clientSecret'),
                              text: _ctx.clientSecret?.decodedData?.[secret.id],
                              "data-testid": `oidc-client-secret-${i}-copy-full-secret`
                            }, null, 8, ["aria-label", "text", "data-testid"])
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_8, "\n                ********" + _toDisplayString(secret.lastFiveCharacters), 1))
                    ]),
                    "item-card-footer": _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('generic.created')), 1),
                          _cache[2] || (_cache[2] = _createTextVNode()),
                          _createElementVNode("span", null, [
                            _cache[1] || (_cache[1] = _createTextVNode(": ", -1)),
                            _createVNode(_component_DateComponent, {
                              value: secret.createdAt
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('tableHeaders.lastUsed')), 1),
                          _cache[4] || (_cache[4] = _createTextVNode()),
                          (!secret.lastUsedAt)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, ": " + _toDisplayString(_ctx.t('oidcclient.usedNever')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                _cache[3] || (_cache[3] = _createTextVNode(": ", -1)),
                                _createVNode(_component_DateComponent, {
                                  value: secret.lastUsedAt
                                }, null, 8, ["value"])
                              ]))
                        ])
                      ])
                    ]),
                    "item-card-actions": _withCtx(() => [
                      _createVNode(_component_ActionMenu, {
                        "data-testid": `oidc-client-secret-${i}-action-menu`,
                        resource: secret,
                        "custom-actions": _ctx.cardActions,
                        onActionInvoked: (payload) => _ctx.handleSecretAction(secret, payload)
                      }, null, 8, ["data-testid", "resource", "custom-actions", "onActionInvoked"])
                    ]),
                    _: 2
                  }, 1032, ["id", "header", "image", "value"]))
                }), 128))
              ]),
              _cache[9] || (_cache[9] = _createTextVNode()),
              _createElementVNode("button", {
                class: "btn role-primary mt-20",
                "data-testid": "oidc-client-add-new-secret",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewSecret && _ctx.addNewSecret(...args)))
              }, _toDisplayString(_ctx.t('oidcclient.addNewSecret')), 1)
            ])
          ]))
        : (_ctx.showNoSecrets)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.t('oidcclient.noClientId')), 1))
          : _createCommentVNode("", true)
  ]))
}